import React from 'react';
import Email from '../../../../components/Email';
import Url from '../../../../components/Url';

const RegulationsContent = () => (
  <>
    <p>
      <strong>Regulamin</strong>
    </p>
    <p>
      <strong>ProteGO Safe</strong>
    </p>
    <p>
      <strong>§ 1</strong>{' '}
    </p>
    <p>
      <strong>Postanowienia ogólne</strong>
    </p>
    <ol>
      <li>
        Niniejszy regulamin (zwany dalej: „<strong>Regulaminem</strong>”)
        normuje zasady i warunki korzystania z aplikacji ProteGO Safe (zwanej
        dalej: „ProteGO Safe” lub “Aplikacją”).
      </li>
      <li>
        Administratorem danych przetwarzanych w aplikacji ProteGO Safe (zwany
        dalej: „<strong>Administratorem Danych</strong>”) tj. Główny Inspektor
        Sanitarny z siedzibą w Warszawie, ul. Targowa 65, 03–729 Warszawa.
      </li>
    </ol>
    <p> </p>
    <p>
      <strong>§ 2</strong>
    </p>
    <p>
      <strong>Definicje</strong>
    </p>
    <p>Ilekroć w Regulaminie mowa o: </p>
    <ol>
      <li>
        <strong>Administratorze Systemu </strong>- rozumie się przez to podmiot
        odpowiedzialny za dostarczenie i funkcjonowanie Aplikacji tj. Ministra
        Cyfryzacji z siedzibą w Warszawie, ul. Królewska 27, 00 – 060 Warszawa.{' '}
      </li>
      <li>
        <strong>Administratorze Danych </strong>- rozumie się przez to Głównego
        Inspektora Sanitarnego z siedzibą w Warszawie, ul. Targowa 65, 03–729
        Warszawa. Administrator Danych samodzielnie ustala cele i sposoby
        przetwarzania Danych Osobowych.
      </li>
      <li>
        <strong>Administratorach</strong> - rozumie się przez to Administratora
        Systemu i Administratora Danych występujących oraz działających
        wspólnie.
      </li>
      <li>
        <strong>Danych Osobowych </strong>- rozumie się przez to podstawowe dane
        o Użytkowniku, tj. nazwa Użytkownika oraz inne dane podawane podczas
        korzystania z ProteGO Safe i określone w Polityce Prywatności, dzięki
        którym możliwe jest określenie tożsamości w sposób bezpośredni lub
        pośredni.
      </li>
      <li>
        <strong>ProteGO Safe</strong> <strong>lub Aplikacji </strong>– rozumie
        się przez to aplikację ProteGO Safe, która umożliwia triaż (samoocenę
        ryzyka infekcji wirusem SARS-CoV-2, stworzoną na podstawie
        kwestionariusza WHO), dziennik zdrowia Użytkownika, wsparcie w
        profilaktyce i zapobieganiu zarażeniem, wczesne ostrzeganie Użytkownika
        potencjalnie zagrożonego zarażeniem, informowanie o istotnych
        informacjach związanych z pandemią wirusa SARS-CoV-2 oraz przypominacz
        bezpiecznych zachowań i nawyków codziennej higieny.
      </li>
      <li>
        <strong>Urządzeniu </strong>– rozumie się przez to elektroniczne
        urządzenie za pośrednictwem, którego Użytkownik uzyskuje dostęp do
        ProteGO Safe (tablet, smartphone itp.) z systemem Android 6.0 lub
        wyższym z dostępem do sklepu Google Play albo z systemem iOS w wersji
        nie niższej niż 10.3 z dostępem do sklepu AppStore.
      </li>
      <li>
        <strong>Użytkowniku </strong>- rozumie się przez to osobę posiadającą
        pełną zdolność do czynności prawnych, która po zaakceptowaniu Regulaminu
        i Polityki Prywatności korzysta z ProteGO Safe.
      </li>
      <li>
        <strong>Regulaminie </strong>– rozumie się dokument, który reguluje
        stosunek prawny między Użytkownikiem a Administratorami zawierany z
        momentem złożenia przez Użytkownika oświadczenia o akceptacji
        Regulaminu.{' '}
      </li>
      <li>
        <strong>Infermedica</strong> - rozumie się przez to Infermedica Sp. z
        o.o. z siedzibą we Wrocławiu, Plac Solny 14/3, 50-062 Wrocław, wpisana
        do rejestru przedsiębiorców Krajowego Rejestru Sądowego prowadzonego
        przez Sąd Rejonowy we Wrocławiu, VI Wydział Gospodarczy Krajowego
        Rejestru Sądowego, pod numerem KRS 0000429183, REGON 021889810, NIP
        8971782877.
      </li>
      <li>
        <strong>WHO</strong> - rozumie się przez to Światową Organizację Zdrowia
        (World Health Organisation).
      </li>
      <li>
        <strong>GIS</strong> - rozumie się przez to Głównego Inspektora
        Sanitarnego.
      </li>
    </ol>
    <p> </p>
    <p>
      <strong>§ 3</strong>
    </p>
    <p>
      <strong>Aplikacja</strong>
    </p>
    <ol>
      <li>
        Korzystanie z Aplikacji ProteGO Safe, jest bezpłatne i obejmuje swym
        zakresem Triaż (samoocenę ryzyka infekcji{' '}
        <Url value="https://www.gov.pl/web/koronawirus">COVID-19</Url>,
        stworzoną na podstawie kwestionariusza WHO), dziennik zdrowia
        Użytkownika, wsparcie w profilaktyce i zapobieganiu zarażeniu,
        informowanie o istotnych informacjach związanych z pandemią{' '}
        <Url value="https://www.gov.pl/web/koronawirus">COVID-19</Url> oraz
        przypominacz bezpiecznych zachowań i nawyków codziennej higieny
        <strong>. </strong>W ramach ProteGO Safe możliwe jest ustalenie
        czynników ryzyka infekcji, tworzenie i prowadzenie historii medycznej,
        istniejących schorzeń, aktualnej farmakoterapii oraz prowadzenie
        dziennika profilaktyki. ProteGO Safe przekazuje informacje i wytyczne
        WHO oraz GIS, ale przekazywane informacje nie mają charakteru
        konsultacji medycznej lub świadczenia zdrowotnego (w tym w szczególności
        medycznego lub farmaceutycznego).
      </li>
      <li>
        Funkcjonalność triaż (samoocena ryzyka zarażenia{' '}
        <Url value="https://www.gov.pl/web/koronawirus">COVID-19</Url>)
        świadczona jest za pośrednictwem aplikacji stworzonej przez Infermedica,
        o której więcej tutaj:{' '}
        <u>https://developer.infermedica.com/docs/covid-19#triage</u>.
      </li>
      <li>
        Przed przystąpieniem do korzystania z ProteGO Safe, Użytkownik powinien
        zaakceptować Regulamin poprzez zaznaczenie odpowiedniego checkboxa.
        Zaprzestanie korzystania z Aplikacji następuje z momentem usunięcia
        ProteGO Safe przez Użytkownika z Urządzenia.
      </li>
    </ol>
    <p> </p>
    <p>
      <strong>§ 4</strong>
    </p>
    <p>
      <strong>Wymagania techniczne</strong>
    </p>
    <ol>
      <li>
        Warunkiem korzystania z ProteGO Safe jest posiadanie przez Użytkownika
        odpowiedniego Urządzenia z aktualnym oprogramowaniem i podłączonego do
        sieci Internet.
      </li>
      <li>
        Korzystanie z ProteGO Safe możliwe jest bez ograniczeń terytorialnych.
      </li>
      <li>
        Administratorzy nie ponoszą odpowiedzialności za utrudnienia w
        korzystaniu z Aplikacji wynikające z niespełnienia wymagań technicznych
        wskazanych w ust. 1, w tym z błędnej konfiguracji Urządzenia, bądź
        wynikające z problemów z Urządzeniem lub łączem internetowym
        Użytkownika.{' '}
      </li>
    </ol>
    <p> </p>
    <p>
      <strong>§5</strong>
    </p>
    <p>
      <strong>Postanowienia dotyczące własności intelektualnej</strong>
    </p>
    <p>
      Administratorzy są uprawnieni do dokonywania zmian funkcjonalności ProteGO
      Safe, celem poprawy jakości Aplikacji oraz do zmiany interfejsu ProteGO
      Safe w całości lub w części. Nazwa ProteGO Safe, logo, zasady działania
      ProteGO Safe, wszystkie jego elementy graficzne, interfejs podlegają
      ochronie prawnej. Oprogramowanie, na którym opiera się ProteGO Safe oraz
      kod źródłowy oddawany jest przez Administratora Systemu w oparciu o
      licencję GNU GPL-3.0, której szczegóły zawarte są pod adresem:{' '}
      <u>https://www.gnu.org/licenses/gpl-3.0.html</u>.{' '}
    </p>
    <p> </p>
    <p>
      <strong>§6</strong>
    </p>
    <p>
      <strong>Odpowiedzialność Administratorów</strong>
    </p>
    <ol>
      <li>
        Administratorzy zobowiązują się do dołożenia wszelkich starań celem
        zapewnienia działania ProteGO Safe bez jakichkolwiek zakłóceń, a także
        przekazania najbardziej aktualnych wytycznych WHO lub GIS.
      </li>
      <li>
        ProteGO Safe ma charakter informacyjny. Administratorzy nie świadczą
        usług zdrowotnych, świadczeń zdrowotnych (w tym w szczególności
        medycznych lub farmaceutycznych), nie są pośrednikami powyższych usług
        oraz świadczeń ani nie realizują działalności leczniczej poprzez ProteGO
        Safe. W związku z powyższym Administratorzy nie ponoszą
        odpowiedzialności za jakiekolwiek skutki wynikające z korzystania przez
        Użytkownika z ProteGO Safe w obszarze zdrowia i życia.
      </li>
      <li>
        Korzystanie z ProteGO Safe nie może zastąpić świadczeń zdrowotnych w tym
        konieczności konsultacji z lekarzem lub właściwą stacją sanitarno -
        epidemiologiczną. Jeżeli Użytkownik dostrzega jakiekolwiek pogorszenie
        stanu zdrowia lub ma wątpliwości co do swojego stanu zdrowia powinien
        niezwłocznie skontaktować się z numerem alarmowym 112 w celu wezwania
        pogotowia ratunkowego lub poinformować właściwą stację sanitarno -
        epidemiologiczną lub udać się do najbliższej placówki służby zdrowia.
      </li>
      <li>
        Jeśli korzystanie z ProteGO Safe nie jest możliwe, jest utrudnione lub
        trwa zbyt długo, a stan zdrowia lub samopoczucie Użytkownika pogarsza
        się, Użytkownik powinien niezwłocznie skontaktować się z numerem
        alarmowym 112 w celu wezwania pogotowia ratunkowego lub poinformować
        właściwą stację sanitarno - epidemiologiczną lub udać się do najbliższej
        placówki służby zdrowia.
      </li>
      <li>
        W przypadkach szczególnych, mających wpływ na bezpieczeństwo lub
        stabilność systemu teleinformatycznego, Administratorzy mają prawo do
        czasowego zaprzestania bądź ograniczenia świadczenia ProteGO Safe lub
        funkcjonalności ProteGO Safe, bez wcześniejszego powiadomienia o tym
        Użytkowników. W szczególności Administratorzy są uprawnieni do
        przeprowadzenia prac konserwacyjnych mających na celu przywrócenie
        bezpieczeństwa i stabilności systemu teleinformatycznego. Użytkownikowi
        ProteGO Safe nie przysługują żadne roszczenia w związku z przerwą lub
        zaprzestaniem świadczenia ProteGO Safe przez Administratorów.
      </li>
      <li>
        Administratorzy mają prawo również zaprzestać świadczenia ProteGO Safe w
        każdym czasie, jeżeli takie uzasadnione żądanie zostanie zgłoszone wobec
        niego przez dostawcę Internetu lub inny uprawniony podmiot. Z
        zastrzeżeniem odpowiednich przepisów prawa oraz niniejszego Regulaminu,
        Administratorzy nie odpowiadają za szkody spowodowane wadliwym
        działaniem systemu transmisji, w tym awariami sprzętu, opóźnieniami i
        zakłóceniami przesyłu informacji.
      </li>
    </ol>
    <p> </p>
    <p>
      <strong>§7</strong>
    </p>
    <p>
      <strong>Warunki zaprzestania korzystania z ProteGO Safe</strong>
    </p>
    <ol>
      <li>
        Użytkownik może zaprzestać korzystania z ProteGO Safe ze skutkiem
        natychmiastowym i bez wskazywania przyczyn poprzez usunięcie ProteGO
        Safe ze swojego Urządzenia.
      </li>
      <li>
        Administrator może zaprzestać dostarczania oraz wspierania i
        aktualizowania ProteGO Safe ze skutkiem natychmiastowym poprzez
        przesłanie Użytkownikowi stosownego oświadczenia za pośrednictwem
        Aplikacji lub poprzez inne dostępne środki komunikacji.
      </li>
    </ol>
    ​
    <p>
      <strong>§8</strong>
    </p>
    <p>
      <strong>Siła Wyższa</strong>
    </p>
    <p>
      Administratorzy nie będą ponosić odpowiedzialności za niewypełnienie
      swoich zobowiązań z tytułu niniejszego Regulaminu w czasie, w każdym
      przypadku gdy ich wypełnienie jest opóźnione lub niemożliwe z powodu
      okoliczności lub wydarzeń będących poza kontrolą Administratorów, co
      uniemożliwia lub znacząco utrudnia Administratorom działanie zgodne z
      Regulaminem, takich jak między innymi: pożar, powódź, nałożenie embargo,
      strajk, zamieszki, niemożność zabezpieczenia materiałów i infrastruktury,
      awaria lub przerwanie pracy maszyn, w każdym przypadku z przyczyn leżących
      poza kontrolą Administratorów lub spowodowane działaniami rządowymi lub
      legislacyjnymi. Jeżeli takie opóźnienie trwać będzie dłużej niż 30
      (trzydzieści) dni, Administratorzy będą mieli prawo zaprzestać
      dostarczania oraz wspierania i aktualizowania ProteGO Safe w trybie
      natychmiastowym.
    </p>
    <p>
      <strong> </strong>
    </p>
    <p>
      <strong>§9</strong>
    </p>
    <p>
      <strong>Ochrona Danych Osobowych</strong>
    </p>
    <p>
      Szczegółowe zasady dotyczące zbierania i Przetwarzania Danych Osobowych
      Użytkowników ProteGO Safe i innych osób korzystających z ProteGO Safe lub
      wszelkich form kontaktu opisane są w Polityce Prywatności.
    </p>
    ​
    <p>
      <strong>§10 Postanowienia końcowe</strong>
    </p>
    <ol>
      <li>
        Administratorzy zastrzegają sobie możliwość wprowadzania zmian w
        Regulaminie. Aktualna wersja Regulaminu będzie dostępna w ProteGO Safe.
      </li>
      <li>
        Administratorzy informują, że instalacja aktualizacji ProteGO Safe może
        być konieczna dla prawidłowego działania Aplikacji i należytego
        zabezpieczenia zawartych w Aplikacji danych.
      </li>
      <li>
        Administratorzy mogą zakończyć działanie ProteGO Safe w każdym czasie.
      </li>
      <li>
        Dla rozpatrywania ewentualnych sporów pomiędzy Administratorami a
        Użytkownikiem właściwe jest prawo polskie.
      </li>
      <li>
        Reklamacje związane z funkcjonowaniem aplikacji mogą być składane
        elektronicznie na adres: <Email>protego@mc.gov.pl</Email>.
      </li>
    </ol>
  </>
);

export default RegulationsContent;
